import _ from "lodash";
import React, { useState } from "react";

import { CATCH_ALL_INSURANCE_OPTIONS } from "@/core/constants";
import { getCarrierMetadata } from "@/components/Common/InsuranceEligibility/carrierMetadata";
import { insuranceListToSelectFormatV2 } from "@/utils/GenericListUtils";

import { AddInsurance } from "../../AddInsurance";
import { InsuranceAcknowledgementPopupHOC } from "../InsuranceAcknowledgementPopupHOC";

export function ChildSignupInsuranceHOC({
  closeAcknowledgementHandler,
  firstName,
  formikProps,
  insuranceCompanyOptions,
  isPrimaryInsurance,
  lastName,
  onFileDelete,
  showAcknowledgementPopup,
  submitAcknowledgementHandler,
  ...props
}) {
  const { errors, handleBlur, handleChange, handleFocus, touched, values } = formikProps;
  const { groupIdTooltipContents, memberIdPlaceholder, memberIdTip, memberIdTooltipContents } =
    getCarrierMetadata(values.insurance.carrier);
  const [noInsurance, setNoInsurance] = useState(false);

  const mapDropDownValue = (value) => ({
    label: value,
    value: value,
  });

  const mappedValues = {
    groupId: values.insurance.group_id,
    insuranceCompany: mapDropDownValue(values.insurance.carrier),
    memberId: values.insurance.member_id,
    policyHolder: values.insurance.policy_holder_question,
  };

  const mappedNames = {
    groupId: "insurance.group_id",
    insuranceBack: "insurance.card_back",
    insuranceCompany: "insurance.carrier",
    insuranceFront: "insurance.card_front",
    memberId: "insurance.member_id",
    policyHolder: "insurance.policy_holder_question",
    policyHolderName: "insurance.policy_holder_name",
    policyRelationship: "insurance.policy_relationship",
  };

  const mappedTouched = {
    groupId: _.get(touched, "insurance.group_id"),
    insuranceCompany: _.get(touched, "insurance.carrier"),
    memberId: _.get(touched, "insurance.member_id"),
    policyHolder: _.get(touched, "insurance.policy_holder_question"),
  };

  const mappedErrors = {
    groupId: _.get(errors, "insurance.group_id"),
    insuranceCompany: _.get(errors, "insurance.carrier"),
    memberId: _.get(errors, "insurance.member_id"),
    policyHolder: _.get(errors, "insurance.policy_holder_question"),
  };

  const generatePolicyHolderName = (e, value) => {
    let policyHolderName = "Other";

    if (value === "yes") {
      policyHolderName = `${firstName} ${lastName}`;
    }
    handleChange({
      ...e,
      target: { ...e.target, name: mappedNames["policyHolderName"], value: policyHolderName },
    });
  };

  const generatePolicyHolderRelationship = (e) => {
    let policyHolderRelationship = "Other";

    handleChange({
      ...e,
      target: {
        ...e.target,
        name: mappedNames["policyRelationship"],
        value: policyHolderRelationship,
      },
    });
  };

  const mappedChangeHandler = (e) => {
    const { name, value } = e.target;
    const mappedName = mappedNames[name];
    let mappedValue = value;

    switch (name) {
      case "insuranceCompany":
        if (CATCH_ALL_INSURANCE_OPTIONS.includes(value)) {
          resetInsurance();
          setNoInsurance(true);
        } else {
          setNoInsurance(false);
        }
        break;

      case "policyHolder":
        generatePolicyHolderName(e, value);
        generatePolicyHolderRelationship(e, value);
        break;
    }

    handleChange({ ...e, target: { ...e.target, name: mappedName, value: mappedValue } });
  };

  const resetInsurance = () => {
    for (const name in mappedNames) {
      if (name === "insuranceCompany") {
        continue;
      }
      formikProps.setFieldValue(mappedNames[name], "");
    }
  };

  const onFileDeleteHandler = (fileName) => {
    let insuranceSide = "insuranceBack";

    if (fileName.startsWith("primary_front")) {
      insuranceSide = "insuranceFront";
    }
    onFileDelete(fileName);
    handleChange({ target: { name: mappedNames[insuranceSide], value: null } });
  };

  const getInsuranceFileNames = () => {
    const fileNameArray = [];
    const frontImage = _.get(values, mappedNames["insuranceFront"]);
    const backImage = _.get(values, mappedNames["insuranceBack"]);

    if (frontImage) {
      fileNameArray.push(frontImage);
    }
    if (backImage) {
      fileNameArray.push(backImage);
    }

    return fileNameArray;
  };

  return (
    <>
      <AddInsurance
        errors={mappedErrors}
        files={getInsuranceFileNames()}
        groupIdTooltipContents={groupIdTooltipContents}
        handleBlur={handleBlur}
        handleChange={mappedChangeHandler}
        handleFocus={handleFocus}
        insuranceCompanyOptions={insuranceListToSelectFormatV2(insuranceCompanyOptions)}
        isChildProfile
        isPrimaryInsurance={isPrimaryInsurance}
        memberIdPlaceholder={memberIdPlaceholder}
        memberIdTip={memberIdTip}
        memberIdTooltipContents={memberIdTooltipContents}
        noInsurance={noInsurance}
        onFileDelete={onFileDeleteHandler}
        touched={mappedTouched}
        values={mappedValues}
        {...props}
      />

      {showAcknowledgementPopup && (
        <InsuranceAcknowledgementPopupHOC
          acknowledgementType={mappedValues.insuranceCompany.value}
          disabled={!showAcknowledgementPopup}
          primaryOnClick={submitAcknowledgementHandler}
          secondaryOnClick={closeAcknowledgementHandler}
        />
      )}
    </>
  );
}
